import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import keycloak from "./keycloak";

keycloak
 .init({
 onLoad: "login-required",
 checkLoginIframe: false,
 pkceMethod: "S256",
 })
 .then((authenticated) => {
 if (!authenticated) {
 keycloak.login();
 } else {
 const root = ReactDOM.createRoot(document.getElementById("root"));
 root.render(<App keycloak={keycloak} />);
 }
 })
 .catch((err) => {
 console.error("Keycloak init failed", err);
 });


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// Added comment to test the jenkins pipeline. This comment is not part of the code and is only for testing purposes.


